import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 48px; /* Add breathing space for last item */
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;
